module.exports = function negotiateShow(value, element, displayValue) {
	if(!value)
		element.style.display = 'none';
	else if(displayValue)
		element.style.display = displayValue;
	else
		element.style.display = 'initial';
};